import React, { memo, useMemo, useCallback } from 'react'

import { arrayOf, bool, string } from 'prop-types'

import ButtonGroupSelector from 'Pods/ThreeDStudio/Shared/ButtonGroupSelector/ButtonGroupSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setEnhancedProvider, setGenerationProvider } from 'Pods/ThreeDStudio/Store/actions/schema'
import { PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import { PROVIDER_LABELS } from './providerLabels'

const DISABLED_TOOLTIP = 'Not available for this settings combination'

function AIEngineSelector({ isEnhanced = false, hiddenProviders = EMPTY_ARRAY }) {
  const generationProvider = useThreeDStudioStore(state => state.schema.generationProvider)
  const enhancedProvider = useThreeDStudioStore(state => state.schema.enhancedProvider)
  const availableGenerationProviders = useThreeDStudioStore(
    state => state.schema.availableGenerationProviders
  )
  const availableEnhancedProviders = useThreeDStudioStore(
    state => state.schema.availableEnhancedProviders
  )
  const provider = isEnhanced ? enhancedProvider : generationProvider
  const availableProviders = isEnhanced ? availableEnhancedProviders : availableGenerationProviders

  const setProvider = isEnhanced ? setEnhancedProvider : setGenerationProvider
  const handleHunyuanClick = useCallback(() => setProvider(PROVIDER.TENCENT), [setProvider])
  const handleMeshyClick = useCallback(() => setProvider(PROVIDER.MESHY), [setProvider])
  const handleTripo3DClick = useCallback(() => setProvider(PROVIDER.TRIPO3D), [setProvider])

  const isProviderDisabled = useCallback((id) => {
    return !availableProviders?.includes(id)
  }, [availableProviders])

  const buttons = useMemo(() => {
    const providerConfig = [
      { id: PROVIDER.TENCENT, onClick: handleHunyuanClick },
      { id: PROVIDER.MESHY, onClick: handleMeshyClick },
      { id: PROVIDER.TRIPO3D, onClick: handleTripo3DClick },
    ]

    return providerConfig
      .filter(({ id }) => !hiddenProviders.includes(id))
      .map(({ id, onClick }) => {
        const disabled = isProviderDisabled(id)

        return {
          id,
          label: PROVIDER_LABELS[id],
          onClick,
          disabled,
          isActive: provider === id,
          tooltipMessage: disabled ? DISABLED_TOOLTIP : undefined,
        }
      })
  }, [
    provider,
    hiddenProviders,
    isProviderDisabled,
    handleHunyuanClick,
    handleMeshyClick,
    handleTripo3DClick,
  ])

  return (
    <ButtonGroupSelector
      buttons={buttons}
      keyName="provider"
      sliceName="schema"
      label="AI Engine"
    />
  )
}

AIEngineSelector.propTypes = {
  isEnhanced: bool,
  hiddenProviders: arrayOf(string),
}

export default memo(AIEngineSelector)
